import React, {
  useRef,
  forwardRef,
  useImperativeHandle,
  useState,
} from "react";
import { Dialog, DialogContent, Box, Typography, Button } from "@mui/material";
import { AlertCircle } from "lucide-react";

const ACCENT_RED = "#dc3545";
const RED_SOFT = "#fff0f0";
const TEXT_PRIMARY = "#1f2733";
const TEXT_SECONDARY = "#5b6472";

const ErrorDialog = forwardRef(function ErrorDialog(props, ref) {
  const [open, setOpen] = useState(false);

  // Parent component isse use kar sakta hai (qbDialogRef.current.openDialog())
  useImperativeHandle(ref, () => ({
    openDialog() {
      setOpen(true);
    },
    closeDialog() {
      setOpen(false);
    },
  }));

  const handleClose = () => {
    setOpen(false);
    if (props?.setIsError) {
      props.setIsError(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          p: 1,
        },
      }}
    >
      <DialogContent sx={{ p: 3, textAlign: "center" }}>
        {/* Error Icon */}
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            background: RED_SOFT,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 2,
          }}
        >
          <AlertCircle size={32} color={ACCENT_RED} strokeWidth={2.2} />
        </Box>

        {/* Title */}
        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: 700,
            color: TEXT_PRIMARY,
            mb: 1,
          }}
        >
          {props.error || "Something went wrong!"}
        </Typography>

        {/* Message */}
        <Typography
          sx={{
            fontSize: "13.5px",
            color: TEXT_SECONDARY,
            lineHeight: 1.6,
            mb: 3,
            wordBreak: "break-word",
          }}
        >
          {props.message || "Please try again later."}
        </Typography>

        {/* Close Button */}
        <Button
          variant="contained"
          fullWidth
          onClick={handleClose}
          sx={{
            background: ACCENT_RED,
            color: "#fff",
            borderRadius: "10px",
            textTransform: "none",
            fontWeight: 700,
            fontSize: "14px",
            py: 1.2,
            boxShadow: "0 4px 12px rgba(220,53,69,0.25)",
            "&:hover": {
              background: "#bb2d3b",
              boxShadow: "0 6px 16px rgba(220,53,69,0.35)",
            },
          }}
        >
          Close
        </Button>
      </DialogContent>
    </Dialog>
  );
});

export default ErrorDialog;
